<div class="payment-link-expired">
  <div class="payment-link-expired__icon" aria-hidden="true">
    <mat-icon>error_outline</mat-icon>
  </div>
  <h1 class="payment-link-expired__title">{{ 'PaymentLinkExpiredPageTitle' | translate }}</h1>
  <p class="payment-link-expired__message">{{ 'PaymentLinkExpiredPageMessage' | translate }}</p>
</div>
